let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eXNo2")).then(() => parcelRequire('4Q4Sb'));